<script setup>
</script>
<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-12 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
          >
            ©
            {{ new Date().getFullYear() }}, Solution by
            <a
              href="https://www.pramixit.com"
              class="font-weight-bold"
              target="_blank"
              > Pramix Holdings
            </a>
            All rights reserved. v1.0.0
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
